import React from 'react'
import PropTypes from 'prop-types'
import StatusBadge from 'components/atoms/status-badge'
import { ACTIVE_STATUS } from 'domains/cms-blog-post/constants'


const propTypes = {
  active_status: PropTypes.string.isRequired
}

/**
 * To give nice look on Cms Blog Post `active_status`.
 * It maps `active_status` to certain style and pass to `StatusBadge`.
 * @param {string} active_status
 */
const ActiveStatusBadge = ({ active_status }) => {

  const colorMap = {
    [ACTIVE_STATUS.ENABLED]  : 'success',
    [ACTIVE_STATUS.DISABLED] : 'danger'
  }

  const color = colorMap[active_status] || 'default'

  return <StatusBadge color={ color } label={ active_status } />
}

ActiveStatusBadge.propTypes = propTypes

export default ActiveStatusBadge
